import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, numeric, confirmed } from 'vee-validate/dist/rules';

extend('email', {
    ...email,
    message: 'Email is not valid.',
});
extend('required', {
    ...required,
    message: 'This field is required.',
});
extend('numeric', {
    ...numeric,
    message: 'This field must be a number.',
});
extend('confirmed', {
    ...confirmed,
    message: 'Invalid data.',
});
extend('countryUs', (value) => {
    if (value === 'US') {
        return true;
    }

    return 'Country must be US';
});

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
